import { useState } from 'react'
import { useFetcher } from 'react-router'
import { useFactsSync } from './facts-sync-context'

// This ensures the code only runs on the client and not during server-side rendering
const isClient = typeof window !== 'undefined'

// Default empty implementation for server-side rendering
const defaultSyncFacts = {
	syncFacts: () => {},
	isLoading: false,
	error: null,
}

export function useSyncFacts() {
	// For consistent hook calls between client and server
	const [clientSide] = useState(isClient)

	// Always call useFactsSync to maintain hook order consistency
	const factsSync = useFactsSync()

	// Always create a fetcher to maintain hook order consistency
	const fetcher = useFetcher()

	// For server-side rendering or during hydration, return the stub implementation
	if (!clientSide) {
		return defaultSyncFacts
	}

	const { startSync, endSync } = factsSync

	// Update the sync state based on fetcher state
	// useEffect(() => {
	// 	if (fetcher.state === 'submitting') {
	// 		startSync()
	// 	} else if (fetcher.state === 'idle' && fetcher.data) {
	// 		endSync()
	// 	}
	// }, [fetcher.state, fetcher.data, startSync, endSync])

	// Function to trigger FACTS sync
	const syncFacts = async (redirectTo?: string) => {
		const formData = new FormData()
		if (redirectTo) {
			formData.append('redirectTo', redirectTo)
		}

		startSync()
		await fetcher.submit(formData, {
			method: 'POST',
			action: '/resources/sync-facts',
		})
		endSync()
	}

	return {
		syncFacts,
		isLoading: fetcher.state !== 'idle',
		error: fetcher.data?.error,
	}
}
